import { upsertEvent, upsertEvents } from '@dispatch/shared/services';
import { UpsertEventParams } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';
import { useMutate } from '../api/useMutate';

export const useUpsertEvent = (
  onSuccess: (response: any) => void,
  onError: () => void,
  onSettled?: () => void
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-resource-events'],
    (data: UpsertEventParams) => upsertEvent(data),
    {
      onSuccess: (response: any) => {
        onSuccess(response);
      },
      onError,
      onSettled: () => {
        queryClient.invalidateQueries(['schedule-data']);
        queryClient.invalidateQueries(['schedule-data-infinite']);
      },
    }
  );

  return {
    upsertEvent: mutate,
    upsertEventError: error,
    upsertEventStatus: status,
  };
};

export const useUpsertEvents = (
  responseFn: (data: {
    success: boolean;
    message: string;
  }) => void | Promise<unknown>
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutate(
    ['upsert-resource-events'],
    (data: UpsertEventParams[]) => upsertEvents(data),
    (data) => {
      queryClient.invalidateQueries(['schedule-data']);
      queryClient.invalidateQueries(['schedule-data-infinite']);
      responseFn(data as { success: boolean; message: string });
    }
  );

  return {
    upsertEvents: mutate,
    upsertEventsError: error,
    upsertEventsStatus: status,
  };
};
